"use client";

import React, {
  createContext,
  useContext,
  useReducer,
  useMemo,
} from "react";

import { AnalyticsReducer, InitialState } from "./reducer";

const AnalyticsContext = createContext(undefined);

export const AnalyticsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AnalyticsReducer, {
    ...InitialState,
  });

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error(
      "useAnalyticsContext must be used within an AnalyticsProvider",
    );
  }
  return context;
};
